import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { Translation } from 'react-i18next';

import headerBackground from '../Images/header-background.png';
import Footer from './Footer';

const pageForm = (
  WrappedComponent,
  title = '',
  minWidth = {},
  maxWidth = {}
) => {
  const styles = (theme) => ({
    root: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      },
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(4),
      minWidth,
      maxWidth,
    },
    button: {
      marginTop: theme.spacing(2),
    },
    headerContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    titleStyle: {
      color: '#ffffff',
      fontWeight: 'bold',
    },
    subTitle: {
      color: '#029E4A',
      fontWeight: 'bold',
    },
    itemMidContainer: {
      marginTop: theme.spacing(10),
    },
  });

  var sectionStyle = {
    height: '345px',
    backgroundImage: `url(${headerBackground})`,
  };
  const Wrapper = (props) => (
    <Translation>
      {(t) => {
        return (
          <div>
            <Grid
              container
              alignItems="center"
              justifyContent="center"
              direction="row"
            >
              <Grid
                className={props.classes.headerContainer}
                style={sectionStyle}
                item
                xs={12}
              >
                <Typography
                  className={props.classes.titleStyle}
                  variant="h3"
                  align="center"
                  gutterBottom
                >
                  {t('onlineServices')}
                </Typography>
              </Grid>
              <Grid className={props.classes.itemMidContainer}>
                <Paper className={props.classes.root} elevation={3}>
                  <Typography
                    className={props.classes.subTitle}
                    align="center"
                    variant="h4"
                  >
                    {title || props.title}
                  </Typography>
                  <WrappedComponent {...props} />
                </Paper>
              </Grid>
            </Grid>
            <Footer />
          </div>
        );
      }}
    </Translation>
  );
  return withStyles(styles)(Wrapper);
};

export default pageForm;



// WEBPACK FOOTER //
// ./src/view/scenes/components/centredForm.js